'use strict';
'use es6';

/**
 * omit keys from an object
 *
 * @param {Object} object object to remove keys from
 * @param {Array} toRemove keys to remove
 * @returns {Object} new object with the keys removed
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var omit = exports.omit = function omit(object) {
  var toRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(object).reduce(function (acc, key) {
    if (toRemove.includes(key)) return acc;
    acc[key] = object[key];
    return acc;
  }, {});
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/utils/omit.js
// module id = 795
// module chunks = 2 3